module.exports = __webpack_public_path__ + "img/geotextil2.01d423f8.png";